/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupEmailTemplatesRoutingModule } from './builder-setup-email-templates-routing.module';
import { EmailTemplateDetailsComponent } from './components/email-template-details/email-template-details.component';
import { EmailTemplateListTabComponent } from './components/email-template-list-tab/email-template-list-tab.component';
import { EmailTemplatePreviewComponent } from './components/email-template-preview/email-template-preview.component';
import { EmailTemplatesTabContainerComponent } from './components/email-template-tab-container/email-template-tab-container.component';
import { EmailTemplateDetailsBusinessService } from './resources/email-template-details-business.service';
import { EmailTemplateTabBusinessService } from './resources/email-template-tab-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupEmailTemplatesRoutingModule,
  ],
  providers: [
    EmailTemplateDetailsBusinessService,
    EmailTemplateTabBusinessService,
  ],
  declarations: [
    EmailTemplatesTabContainerComponent,
    EmailTemplateDetailsComponent,
    EmailTemplateListTabComponent,
    EmailTemplatePreviewComponent,
  ],
})
export class BuilderSetupEmailTemplatesModule {
}
